import React from 'react'
import CustomizedDialogs from '../../common/CustomizedDialogs'
import { Box, Divider, Typography } from '@mui/material'
import MButton from '../../common/MButton'

const GSTModal = (props) => {
    const { open, data = {}, titleText = '', onClose = () => { } } = props

    let address = data.DoorNo + ", " + data.FloorNo + ", " + data.BuildingName + ", " + data.Street + ", " + data.City + ", " + data.State + ", " + data.Pincode

    const columnDef = [
        { label: 'GSTIN', value: data?.GSTN || '' },
        { label: 'Company Name', value: data?.CompanyName || '' },
        { label: 'Company Type', value: data?.CompanyType || '' },
        { label: 'Address', value: address },
        { label: 'Trade Name', value: data?.TradeName || '' },
        { label: 'Status', value: data?.Status },
    ]
    return (
        <CustomizedDialogs padding='0px' open={open} onClose={onClose} width={'500px'} titleText={titleText}>
            <Box sx={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {columnDef.map((obj, index) => (
                    <Box sx={{ display: 'flex' }}>
                        <Typography sx={{ minWidth: '120px' }}>{obj.label}</Typography>
                        <Typography sx={{ paddingX: '4px' }}>:</Typography>
                        <Typography sx={{ fontWeight: '500', marginBottom: '10px' }}>{obj.value}</Typography>
                    </Box>
                ))}
            </Box>
            <Divider sx={{ borderColor: '#00000033' }} />
            <Box sx={{ padding: '10px 16px', display: 'flex', justifyContent: 'center' }}>
                <MButton
                    id='info-modal-okBnt'
                    btnName='Ok'
                    onClick={onClose}
                    style={{ minWidth: '100%' }}
                />
            </Box>
        </CustomizedDialogs>
    )
}

export default GSTModal